import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import * as ReactRouterPropTypes from 'react-router-prop-types';
import { compose } from 'recompose';
import Container from '../../components/dashboard/container';
import { isAuthor } from '../../components/access';
import { withAuthorization } from '../../model/Session';
import Form from './form';
import { FirebasePropType, withFirebase } from '../../model/Firebase';
import * as ROUTES from '../../constants/routes';
import Fields from './fields';
import Loading from '../../components/loading';

const redirect = (history) => {
  history.push(ROUTES.CATEGORIES);
};

const EditCategory = ({ history, match, firebase }) => {
  const [category, setCategory] = React.useState(null);
  React.useEffect(() => {
    const { id } = match.params;
    if (id) {
      firebase.category(id)
        .get()
        .then((doc) => {
          const categoryData = Fields.getInstance(doc);
          categoryData.parents = [...Object.keys(categoryData.parents)];
          setCategory(categoryData);
        })
        .catch(() => redirect(history));
    } else {
      redirect(history);
    }
  }, [firebase, history, match.params]);

  let title = 'Cargando...';
  let component = <Loading />;
  if (category) {
    title = `Editando ${category.name}`;
    component = <Form categoryValues={category} />;
  }

  return (
    <Container backAction={() => redirect(history)} title={title}>
      <Grid container spacing={3} justify="center">
        <Grid item xs={12} md={6}>
          {component}
        </Grid>
      </Grid>
    </Container>
  );
};

EditCategory.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  firebase: FirebasePropType.isRequired,
};

export default compose(
  withAuthorization(isAuthor),
  withFirebase,
  withRouter,
)(EditCategory);
